import
{
    UserPermissions,
    permissionAllowed,
    permissionAvailable,
    permissionEmpty
} from "@ews/react-data";

import { useMyPermissions, useMyProfile, useMyProfileId } from "../../../Login/LoginProvider";
import { useModifyUserPermissions, useUser, useUserPermissions } from "../../../ReactData/user";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import { PermissionsSettingsProps } from "./types";

const PermissionsSettings: React.FC<PermissionsSettingsProps> = ({ id }) =>
{
    const myPermissions = useMyPermissions();

    const allowedToEdit = permissionAllowed(myPermissions.createUser || 0);

    const me = useMyProfileId();

    const user = useUser(id);

    const userPermission = useUserPermissions(id);
    //const customerPermission = useCustomerPermissions(user.customerId || "");
    const modifyPermission = useModifyUserPermissions();

    const modify = async (data: UserPermissions) =>
    {
        await modifyPermission(user.id!, data);
    };

    const setPermission = async (permission: keyof UserPermissions, value: boolean) =>
    {
        return modify({ [permission]: value ? 1 : 0 } as unknown as UserPermissions);
    };

    if (me === id) return <></>;

    return <>
        <SettingsCol>
            {
                permissionAllowed(myPermissions.isAdmin!) || permissionAllowed(userPermission.isAdmin!) ?
                    <SettingsCheckbox
                        text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_USERSUBADMIN"}
                        disabled={!permissionAllowed(myPermissions.isAdmin!) || !permissionAvailable(userPermission.isAdmin!)}
                        checked={permissionAllowed(userPermission.isAdmin!)}
                        onChange={(checked) => { setPermission('isAdmin', checked); }} />
                    : null
            }
            {/* <SettingsCheckbox text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_USERWEBSHOP"} checked={RightsDataRef.current.licencesWebshop} onChange={(checked) => { RightsDataRef.current.licencesWebshop = checked; }} /> */}
            {

                ((permissionAllowed(myPermissions.isAdmin!) && myPermissions.licenseManagement) || userPermission.licenseManagement === true) ?
                    <SettingsCheckbox
                        disabled={!(permissionAllowed(myPermissions.isAdmin!) && myPermissions.licenseManagement)}
                        text={"[REACT_IS_ALLOWED_TO_SET_LICENSES]"}
                        checked={userPermission.licenseManagement || false}
                        onChange={(licenseManagement) => { modify({ licenseManagement } as UserPermissions); }} />
                    : null
            }

            {
                userPermission.allowMultipleLogin || permissionAllowed(myPermissions.isAdmin!) ?
                    <SettingsCheckbox
                        text={"PLG_USER_PROFILE_LST_FIELD_PERMISSIONS_MULTIPLELOGIN"}
                        disabled={!permissionAllowed(myPermissions.isAdmin!)}
                        checked={userPermission.allowMultipleLogin || false}
                        onChange={(allowMultipleLogin) => { modify({ allowMultipleLogin } as UserPermissions); }} />
                    : null
            }

            <SettingsCheckbox
                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_USERSCREATE"}
                disabled={allowedToEdit ? !(permissionAvailable(userPermission.createUser || 0)) : true}
                /* disabled={!(permissionAvailable(permission.createUser || 0))} */
                checked={permissionAllowed(userPermission.createUser!)}
                onChange={(createUser) => { setPermission("createUser", createUser); }} />
            <SettingsCheckbox
                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_CUSTOMERSCREATE"}
                disabled={allowedToEdit ? !permissionAvailable(userPermission.createCustomer!) : true}
                /* disabled={!permissionAvailable(userPermission.createCustomer!)} */
                checked={permissionAllowed(userPermission.createCustomer!)}
                onChange={(createCustomer) => { setPermission("createCustomer", createCustomer); }} />
            <SettingsCheckbox
                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_CONSTRUCTIONSAVAILABLE"}
                disabled={allowedToEdit ? !permissionAvailable(userPermission.listAllSystems!) : true}
                /* disabled={!permissionAvailable(userPermission.listAllSystems!)} */
                checked={permissionAllowed(userPermission.listAllSystems!)}
                onChange={(listAllSystems) => { setPermission("listAllSystems", listAllSystems); }} />
            <SettingsCheckbox
                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_CONSTRUCTIONCREATE"}
                disabled={allowedToEdit ? !permissionAvailable(userPermission.grantSystemAccess!) : true}
                /* disabled={!permissionAvailable(userPermission.grantSystemAccess!)} */
                checked={permissionAllowed(userPermission.grantSystemAccess!)}
                onChange={(grantSystemAccess) => { setPermission("grantSystemAccess", grantSystemAccess); }} />
            <SettingsCheckbox
                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_CONSTRUCTIONSREQUESTVIEW"}
                disabled={allowedToEdit ? !permissionAvailable(userPermission.createShare!) : true}
                /* disabled={!permissionAvailable(userPermission.createShare!)} */
                checked={permissionAllowed(userPermission.createShare!)}
                onChange={(createShare) => { setPermission("createShare", createShare); }} />
            <SettingsCheckbox
                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_CONSTRUCTIONSUSE"}
                disabled={allowedToEdit ? !permissionAvailable(userPermission.permitAccessLevel2!) : true}
                /* disabled={!permissionAvailable(userPermission.permitAccessLevel2!)} */
                checked={permissionAllowed(userPermission.permitAccessLevel2!)}
                onChange={(permitAccessLevel2) => { setPermission("permitAccessLevel2", permitAccessLevel2); }} />
            <SettingsCheckbox
                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_USERS"}
                disabled={allowedToEdit ? !permissionAvailable(userPermission.permitAccessLevel3!) : true}
                /* disabled={!permissionAvailable(userPermission.permitAccessLevel3!)} */
                checked={permissionAllowed(userPermission.permitAccessLevel3!)}
                onChange={(permitAccessLevel3) => { setPermission("permitAccessLevel3", permitAccessLevel3); }} />
            <SettingsCheckbox
                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_CONSTRUCTIONSPUSHLOWERLEVEL"}
                disabled={allowedToEdit ? !permissionAvailable(userPermission.notifyAllSystem!) : true}
                /* disabled={!permissionAvailable(userPermission.notifyAllSystem!)} */
                checked={permissionAllowed(userPermission.notifyAllSystem!)}
                onChange={(notifyAllSystem) => { setPermission("notifyAllSystem", notifyAllSystem); }} />

        </SettingsCol>
        <SettingsCol>
            <SettingsCheckbox
                text={"PLG_USER_PROFILE_LST_FIELD_PERMISSIONS_MEASUREMENTLEVEL2"}
                disabled={!allowedToEdit}
                checked={userPermission.detectorValuesAccessLevel2 || false}
                onChange={(detectorValuesAccessLevel2) => { modify({ detectorValuesAccessLevel2 } as UserPermissions); }} />
            <SettingsCheckbox
                text={"PLG_USER_PROFILE_LST_FIELD_PERMISSIONS_ISAUTHLEVEL1"}
                disabled={!allowedToEdit}
                checked={userPermission.listViewAccessLevel1 || false}
                onChange={(listViewAccessLevel1) => { modify({ listViewAccessLevel1 } as UserPermissions); }} />
            <SettingsCheckbox
                text={"COM_FACPMANAGEMENT_CUSTOMER_FIELD_USEIFACCESSISENABLED"}
                disabled={allowedToEdit ? permissionAvailable(userPermission.restrictOperationToApprovedSession!) : true}
                checked={!permissionEmpty(userPermission.restrictOperationToApprovedSession!)}
                onChange={(restrictOperationToApprovedSession) => { setPermission("restrictOperationToApprovedSession", restrictOperationToApprovedSession); }} />

        </SettingsCol>
        <SettingsCol>

        </SettingsCol>
    </>;
};

export default PermissionsSettings;
